/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

export const screens = {
	// mortgageEffortRate: {
	// 	name: 'mortgageEffortRate',
	// 	actions: [],
	// 	loader: (): React.LazyExoticComponent<any> =>
	// 		React.lazy(() => import('./mortgageEffortRate/mortgageEffortRate')),
	// },
	simulator: {
		name: 'simulator',
		actions: [],
		loader: (): React.LazyExoticComponent<any> => React.lazy(() => import('./simulator/simulator')),
	},
} as const;
